import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/dashboards/my-reports-icon.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-27df7090"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home-page",
  "data-test": "guest-home-page"
}
const _hoisted_2 = { class: "center-flex" }
const _hoisted_3 = { class: "homepage-content-container" }
const _hoisted_4 = { class: "reports-container text-big" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reports-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "My Reports",
    class: "guest-my-reports-image",
    "data-test": "guest-my-reports-image"
  }),
  /*#__PURE__*/_createElementVNode("h2", null, "My Reports")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "center-flex repeat-strengths-mapping-container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"50px"} }, null, -1))

import { computed, ref } from "vue";
import axios from "axios";
import HomePageHeader from "../../components/home-page-header.vue";
import { UserDetailsApiModel } from "../../api-models";
import { csContext } from "../../services/cs-context";
import MyReportsTable from "../../components/my-reports/my-reports-table.vue";
import JyreInsightsCard from "../../components/jyre-insights-card.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'guest-home-page',
  setup(__props) {

const user = ref<UserDetailsApiModel>(csContext.user);

const repeatStrengthsMapping = async () => {
  const { request } = await axios.post("/review/reviewyourselfagain");
  if (request?.responseURL.length > 0) {
    window.location.href = request.responseURL;
  }
};

const isAssessUserWithSolo = computed(() => {
  return (
    csContext.userDocument?.platformPermissions.includes("AssessPlanAccess") &&
    csContext.userDocument?.hasCompletedFoundationsSession
  );
});

const hasActiveSubscription = computed(() => {
  return csContext.user.subscriptionLevel === "Full";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(HomePageHeader, {
          "first-name": user.value.firstName,
          "data-test": "guest-home-title"
        }, null, 8, ["first-name"]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(MyReportsTable, { "data-test": "guest-my-reports-table" })
        ]),
        (isAssessUserWithSolo.value && hasActiveSubscription.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn btn-repeat-strengths-mapping",
                onClick: repeatStrengthsMapping,
                "data-test": "repeat-strengths-mapping-btn"
              }, " Create new Solo Report ")
            ]))
          : _createCommentVNode("", true),
        (isAssessUserWithSolo.value)
          ? (_openBlock(), _createBlock(JyreInsightsCard, { key: 1 }))
          : _createCommentVNode("", true),
        _hoisted_7
      ])
    ])
  ]))
}
}

})